import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * Copyright 2019, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Fragment } from 'react';
import { css } from '@emotion/react';
import TableRow from '../TableRow';
import TableHeader from '../TableHeader';
import { mapCellProps, getSortParams } from '../../utils';
import styled from '../../../../styles/styled';
const fixedStyles = ({ scrollable, top, rowHeaders, theme, }) => scrollable &&
    top && // we need this check despite the TS types
    css `
    transform: translateY(${top}px);

    ${theme.mq.untilMega} {
      transform: ${rowHeaders ? 'unset' : `translateY(${top}px)`};
    }
  `;
const Thead = styled.thead `
  ${fixedStyles}
`;
/**
 * TableHead for the Table component. The Table handles rendering it.
 */
const TableHead = ({ headers = [], rowHeaders = false, condensed, scrollable, top, onSortBy, sortDirection, sortedRow, onSortEnter, onSortLeave, }) => (_jsx(Thead, Object.assign({ scrollable: scrollable, top: top, rowHeaders: rowHeaders }, { children: !!headers.length && (_jsx(TableRow, { children: headers.map((header, i) => {
            const cellProps = mapCellProps(header);
            const { sortable, sortLabel } = cellProps;
            const sortParams = getSortParams({
                rowIndex: i,
                sortable,
                sortDirection,
                sortLabel,
                sortedRow,
            });
            return (_jsx(Fragment, { children: _jsx(TableHeader, Object.assign({}, cellProps, { condensed: condensed, fixed: rowHeaders && i === 0, onClick: sortParams.sortable
                        ? onSortBy && (() => onSortBy(i))
                        : undefined, onMouseEnter: sortParams.sortable
                        ? onSortEnter && (() => onSortEnter(i))
                        : undefined, onMouseLeave: sortParams.sortable
                        ? onSortLeave && (() => onSortLeave(i))
                        : undefined, sortParams: sortParams })) }, `table-header-${i}`));
        }) })) })));
export default TableHead;
